module.exports = __webpack_public_path__ + "img/MFT白皮书_30.2b233671.jpg";